import { BaseModel } from "sjs-base-model";

export default class A7ProductsRequestModel extends BaseModel {
    title = "";
    firstName = "";
    lastName = "";
    companyName = "";
    companyPhone = "";
    companyEmail = "";
    street = "";
    postalCode = "";
    city = "";
    country = "";
    tin = "";
    product = "";
    effectiveDate = 0;
    message = "";

    constructor(data) {
        super();
        this.update(data);
    }
}